"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToBrand = exports.GetBrandConfiguration = exports.getUserPortalUrl = exports.getOrderingPortalUrl = exports.getCognitoConfigIdentifier = exports.getBrandProfileOption = exports.getImpersonatedBrandInfo = exports.getBrandsList = exports.BrandType = void 0;
var toca_shared_utils_1 = require("toca-shared-utils");
var brandConfig_PROD = __importStar(require("./BrandConfig_Prod.json"));
var brandConfig_QA = __importStar(require("./BrandConfig_Qa.json"));
var brandConfig_local = __importStar(require("./BrandConfig_local.json"));
var BrandProfileOption_1 = require("./BrandProfileOption");
__exportStar(require("./BrandProfileOption"), exports);
var BrandType;
(function (BrandType) {
    BrandType[BrandType["Undefined"] = 0] = "Undefined";
    BrandType[BrandType["ManagedBrand"] = 1] = "ManagedBrand";
    BrandType[BrandType["SelfManagedBrand"] = 2] = "SelfManagedBrand";
    BrandType[BrandType["Tracking"] = 3] = "Tracking";
})(BrandType || (exports.BrandType = BrandType = {}));
var isQAEnvironment = function (hostname) {
    return hostname.includes('qa.test.');
};
var isLocalEnvironment = function (hostname) {
    return hostname.includes('localhost');
};
var getEnvironmentSpecificAdminOrderingPortalUrl = function () {
    var hostname = window.location.hostname;
    var orderingPortalUrl = isQAEnvironment(hostname)
        ? toca_shared_utils_1.Contants.AdminImpersonation.QAOrderingPortalUrl
        : isLocalEnvironment(hostname)
            ? toca_shared_utils_1.Contants.AdminImpersonation.LocalOrderingPortalUrl
            : toca_shared_utils_1.Contants.AdminImpersonation.ProdOrderingPortalUrl;
    return orderingPortalUrl;
};
var getEnvironmentSpecificAdminUserPortalUrl = function () {
    var hostname = window.location.hostname;
    return isQAEnvironment(hostname)
        ? toca_shared_utils_1.Contants.AdminImpersonation.QAUserPortalUrl
        : isLocalEnvironment(hostname)
            ? toca_shared_utils_1.Contants.AdminImpersonation.LocalUserPortalUrl
            : toca_shared_utils_1.Contants.AdminImpersonation.ProdUserPortalUrl;
};
var getBrandsList = function () {
    var hostname = window.location.hostname;
    var brandsList = isQAEnvironment(hostname)
        ? brandConfig_QA.brands
        : isLocalEnvironment(hostname)
            ? brandConfig_local.brands
            : brandConfig_PROD.brands;
    return brandsList;
};
exports.getBrandsList = getBrandsList;
var getImpersonatedBrandInfo = function () {
    var brandsList = (0, exports.getBrandsList)();
    var isImpersonating = toca_shared_utils_1.AppUtils.isImpersonating();
    if (isImpersonating) {
        var impersonatedBrandId_1 = toca_shared_utils_1.AppUtils.getImpersonatingBrandId();
        if (impersonatedBrandId_1) {
            var brand = brandsList.find(function (brandConfig) { return brandConfig.brandConfiguration.brandId === impersonatedBrandId_1; });
            if (brand) {
                return JSON.parse(JSON.stringify(brand));
            }
        }
    }
    return null;
};
exports.getImpersonatedBrandInfo = getImpersonatedBrandInfo;
var getBrandProfileOption = function () {
    var impersonatedBrand = (0, exports.getImpersonatedBrandInfo)();
    var brand = impersonatedBrand || (0, exports.GetBrandConfiguration)();
    var brandId = +brand.brandConfiguration.brandId;
    var brandProfileOption = (0, BrandProfileOption_1.getBrandProfileOptionByBrandId)(brandId);
    return brandProfileOption;
};
exports.getBrandProfileOption = getBrandProfileOption;
var getCognitoConfigIdentifier = function () {
    var isImpersonating = toca_shared_utils_1.AppUtils.isImpersonating();
    return isImpersonating
        ? toca_shared_utils_1.Contants.AdminImpersonation.AdminCognitoConfigIdentifier
        : BrandConfiguration().brandConfiguration.cognitoConfigIdentifier;
};
exports.getCognitoConfigIdentifier = getCognitoConfigIdentifier;
var getOrderingPortalUrl = function () {
    var isImpersonating = toca_shared_utils_1.AppUtils.isImpersonating();
    return isImpersonating
        ? getEnvironmentSpecificAdminOrderingPortalUrl()
        : BrandConfiguration().brandConfiguration.brandUrl.orderingPortalUrl;
};
exports.getOrderingPortalUrl = getOrderingPortalUrl;
var getUserPortalUrl = function () {
    var isImpersonating = toca_shared_utils_1.AppUtils.isImpersonating();
    return isImpersonating
        ? getEnvironmentSpecificAdminUserPortalUrl()
        : BrandConfiguration().brandConfiguration.brandUrl.userPortalUrl;
};
exports.getUserPortalUrl = getUserPortalUrl;
var BrandConfiguration = function () {
    var brandsList = (0, exports.getBrandsList)();
    var impersonatedBrand = (0, exports.getImpersonatedBrandInfo)();
    if (impersonatedBrand) {
        return impersonatedBrand;
    }
    var domain = window.location.hostname;
    var brand = brandsList.find(function (brandConfig) {
        if (brandConfig.domain.includes(domain)) {
            return brandConfig;
        }
    });
    if (!brand) {
        brand = brandsList.find(function (brandConfig) {
            if (brandConfig.domain.includes('default')) {
                return brandConfig;
            }
        });
    }
    return JSON.parse(JSON.stringify(brand));
};
var GetBrandConfiguration = function () {
    return BrandConfiguration();
};
exports.GetBrandConfiguration = GetBrandConfiguration;
var convertToBrand = function (brand, inputString) {
    var _a = brand.brandConfiguration, name = _a.name, studentTerminology = _a.studentTerminology, studentTerminologyPlural = _a.studentTerminologyPlural, yearLevelTerminology = _a.yearLevelTerminology, classTerminology = _a.classTerminology, schoolLevelTerminology = _a.schoolLevelTerminology;
    return inputString
        .replace(/<BRANDNAME>/g, name)
        .replace(/<SUBUSER>/g, studentTerminology)
        .replace(/<subuser>/g, studentTerminology.toLocaleLowerCase())
        .replace(/<SUBUSERS>/g, studentTerminologyPlural)
        .replace(/<subusers>/g, studentTerminologyPlural.toLocaleLowerCase())
        .replace(/<SCHOOL>/g, schoolLevelTerminology)
        .replace(/<school>/g, schoolLevelTerminology.toLocaleLowerCase())
        .replace(/<YEARLEVEL>/g, yearLevelTerminology)
        .replace(/<yearlevel>/g, yearLevelTerminology.toLocaleLowerCase())
        .replace(/<CLASS>/g, classTerminology)
        .replace(/<class>/g, classTerminology.toLocaleLowerCase());
};
exports.convertToBrand = convertToBrand;
//# sourceMappingURL=BrandConfig.js.map